import React from "react";
import { Icon } from "@iconify/react";

const DoctorReviewCard = ({ doctor }) => {
  return (
    <div className="flex-shrink-0 w-[300px] snap-start bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 mr-4 flex flex-col justify-between">
      {/* Top: stars + quote icon */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <div className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map((s) => (
              <Icon key={s} icon="solar:star-bold" className="w-3.5 h-3.5 text-amber-400" />
            ))}
          </div>
          <Icon icon="solar:quote-up-bold-duotone" className="w-6 h-6 text-indigo-100" />
        </div>

        {/* Quote */}
        <p className="text-sm text-gray-600 leading-[1.75] line-clamp-4 font-normal">
          {doctor?.doctorReview}
        </p>
      </div>

      {/* Bottom: avatar */}
      <div className="flex items-center gap-3 mt-5 pt-5 border-t border-gray-50">
        <img
          src={doctor?.doctorImg}
          alt={doctor?.doctorName}
          className="w-10 h-10 rounded-full object-cover border-2 border-indigo-100 flex-shrink-0"
        />
        <div>
          <p className="text-sm font-bold text-gray-900 font-heading">{doctor?.doctorName}</p>
          <p className="text-xs font-medium text-indigo-600 mt-0.5">{doctor?.specialist}</p>
        </div>
      </div>
    </div>
  );
};

export default DoctorReviewCard;
